import React from "react";
import { css } from "@emotion/react";
import { Label, Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { dateValidation } from "@/components/validations";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  name: string;
  labelRequired: boolean;
};

const RepresentativeBirthDateFormFieldComponent = (
  { name, labelRequired }: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          代表者 生年月日 {labelRequired && <Label variant="required" />}
        </Font>
      </div>
      <div css={inputWrapper}>
        <div css={textFieldWrapper}>
          <FormTextField
            name={name}
            placeholder={"例）1989/01/01"}
            registerOptions={{
              validate: dateValidation,
            }}
            ref={ref}
          />
        </div>
        <div css={errorWrapper}>
          <FormErrorMessage name={name} />
        </div>
      </div>
    </div>
  );
};

export const RepresentativeBirthDateFormField = React.forwardRef(
  RepresentativeBirthDateFormFieldComponent
);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  flex: 1,
});

const textFieldWrapper = css({
  maxWidth: "196px",
});

const errorWrapper = css({
  flex: 1,
});
